import { Injectable } from '@angular/core';
import { ApiService } from '@core/http';
import { environment } from '@env';
import { DoctorRatingDTO } from '@project/view-models';

@Injectable({
  providedIn: 'root',
})
export class RatingApiProviderService {
  constructor(private apiService: ApiService) {}

  postDoctorRating(doctorRating: DoctorRatingDTO) {
    return this.apiService.post(`${environment.environmentVariables.apiCoreUrl}/DoctorRating`, doctorRating);
  }
}
